import { useDispatch, useSelector } from 'react-redux';
import { Box, Text } from '@quintoandar-tokko/jopijs';
import RadioButtonsGroup from '../../RadioButtonsGroup';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import styles from './closedLeads.module.scss';
import { CLOSED_LEADS } from '../../constants';
import { setClosedLeads } from '@/store/slices/components/dashboard/DashboardSlice';
import ClosedLeadsRow from './ClosedLeadsRow';
import PerformanceCard from '../PerformanceCard';
import ToolTip from '@/components/ToolTip/ToolTip';
import { useTrackPerformanceTabCard } from '../../customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '../../constants/track';

export default function ClosedLeadsContent() {
  const dispatch = useDispatch();
  const { closedLeads } = useSelector((state) => state.DashboardSlice);
  const track = useTrackPerformanceTabCard();
  const { value, options, selectedOption, variation, percentage_status, icon } =
    closedLeads;
  const selectedList = options[selectedOption].list;
  const selectedOthers = options[selectedOption].others;

  const othersCount = selectedOthers.reduce((acc, curr) => acc + curr.count, 0);
  const othersPercentage = selectedOthers.reduce(
    (acc, curr) => acc + curr.percentage,
    0
  );
  const handleClickRadio = (item) => {
    dispatch(setClosedLeads({ key: 'selectedOption', value: item.id }));
    track.closedLeads(TRACK_ELEMENT.RADIO_BUTTON_OPTION);
  };

  const getTooltipContent = () => {
    const maxVisible = 12;
    const visible = selectedOthers.slice(0, maxVisible);
    const remaining = selectedOthers.length - maxVisible;

    return (
      <>
        {visible.map((event) => (
          <Text key={event.id}>{`${event.name}: ${event.count}`}</Text>
        ))}
        {remaining > 0 && (
          <Text>{`${Trans(translations, 'CountMore', remaining)}...`}</Text>
        )}
      </>
    );
  };

  const allowedOptions = [
    {
      id: CLOSED_LEADS.CLOSING_REASON,
      text: Trans(translations, 'ClosingReason'),
    },
    {
      id: CLOSED_LEADS.QUALIFICATION,
      text: Trans(translations, 'Qualification'),
    },
  ];

  return (
    <>
      <PerformanceCard.Summary
        value={value}
        percentageStatus={percentage_status}
        tendency={variation}
        icon={icon}
      >
        <RadioButtonsGroup
          allowedOptions={allowedOptions}
          selectedOption={selectedOption}
          onClickRadio={handleClickRadio}
        />
      </PerformanceCard.Summary>
      <PerformanceCard.Content>
        <Box className={styles.rowsWrapper}>
          {selectedList.map((lead) => (
            <ClosedLeadsRow
              key={lead.name}
              name={lead.name}
              percentage={lead.percentage}
              count={lead.count}
              qualification={lead.qualification}
            />
          ))}

          {selectedOthers.length > 0 && (
            <ToolTip title={getTooltipContent()}>
              <ClosedLeadsRow
                name={Trans(translations, 'Others')}
                percentage={othersPercentage}
                count={othersCount}
              />
            </ToolTip>
          )}
        </Box>
      </PerformanceCard.Content>
    </>
  );
}
